import React, { useState, useEffect, useContext } from 'react';
import { CgProfile } from 'react-icons/cg'
import { useNavigate, useLocation } from 'react-router-dom'
import { Menu, Button, Group, Burger, MantineProvider, Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { BedethequeContext } from '../utils/context/bedetheque'
import { useAuthState, useAuthDispatch, signIn, signOut, setUserPrefs } from '../utils/context/auth';
import colors from '../utils/style/colors';
import '../utils/style/modalLogin.css'
import '../utils/style/topMenu.css'

const lockRoutes = ['/grab', '/stats', '/dedicaces', '/tomefinder'];

function TopMenu() {
    const { bedetheque } = useContext(BedethequeContext);
    const { user: loggedUser, status, justSignedIn, userPrefs } = useAuthState();
    const [editionMode, setEditionMode] = useState(userPrefs?.editionMode);
    const dispatch = useAuthDispatch();

    const [burgerOpened, setBurgerOpened] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const locPathname = () => {
        if(location.pathname.includes('/serie')) {
            let tSerie = location.pathname.split('/')[2]
            if(!!tSerie) {
                let serieFromCtxt = bedetheque.filter((el) => el.idserie === parseInt(tSerie))
                if(serieFromCtxt.length) {
                    return '- '+serieFromCtxt[0].serie
                }
            } else {
                return '/'
            }
        } else {
            return location.pathname
        }
    }

    document.title = `Comics ${locPathname()}`;

    useEffect(() => {
        if (status !== 'resolved') return;
        if (loggedUser) {
            if (!justSignedIn) return;
            showNotification({
                title: '🔓 Signed in',
                styles: (theme) => ({
                    root: {
                        backgroundColor: theme.colors.blue[6],
                        borderColor: theme.colors.blue[6],
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                        '&:hover': { backgroundColor: theme.white },
                    },
                }),
            })
        } else {
            if (editionMode) setEditionMode(false)
            if (lockRoutes.indexOf(location.pathname) > -1) navigate('/')
        }
    }, [loggedUser, status, justSignedIn])

    useEffect(() => {
        if (loggedUser) {
            setUserPrefs(dispatch, { editionMode })
        }
    }, [editionMode])

    function navTo(route) {
        navigate(route);
    }

    return (
        <>
            <div className='navBarContainer'>

                <div className='navBarLeft'>
                </div>

                <div className='navBarCenter'>
                    <nav>
                        <Group position="center">
                            <MantineProvider inherit theme={{ defaultGradient: { from: 'orange', to: 'yellow', deg: 45, }, }} >
                                <Button size={'xs'} variant="gradient" onClick={() => navTo("/")}>&nbsp;ACCUEIL&nbsp;</Button>
                            </MantineProvider>

                            <Menu transition="rotate-left" transitionDuration={150} shadow="xs" width={280} onChange={(opened) => {setBurgerOpened(opened)}}>
                                <Menu.Target>
                                    <Burger
                                        opened={burgerOpened}
                                        onClick={() => setBurgerOpened((o) => !o)}
                                    />
                                </Menu.Target>

                                <Menu.Dropdown>
                                    <Menu.Label>
                                        {loggedUser && (
                                            <>Welcome {loggedUser.username}</>
                                        )}
                                        {!loggedUser && (
                                            <>Mode invité</>
                                        )
                                        }
                                    </Menu.Label>
                                    <Menu.Item variant="big" onClick={() => navTo("/search")}><Text fz="xl" fw={700}>🔍 RECHERCHE</Text></Menu.Item>
                                    <Menu.Item onClick={() => navTo("/wishlist")}><Text fz="xl" fw={700}>💲 WISHLIST</Text></Menu.Item>
                                    { loggedUser &&
                                    <Menu.Item onClick={() => navTo("/dedicaces")}><Text fz="xl" fw={700}>🔖 DEDICACES</Text></Menu.Item>
                                    }
                                    <Menu.Divider />
                                    <Menu.Label>Admin zone</Menu.Label>
                                    { loggedUser &&
                                        <>
                                        <Menu.Item onClick={() => navTo("/grab")}><Text fz="xl" fw={700}>🔄️ GRAB ALBUM</Text></Menu.Item>
                                        <Menu.Item onClick={() => navTo("/tomefinder")}><Text fz="xl" fw={700}>🐍 TOME FINDER</Text></Menu.Item>
                                        <Menu.Item onClick={() => navTo("/stats")}><Text fz="xl" fw={700}>📅 STATISTIQUES</Text></Menu.Item>
                                        </>
                                    }
                                    { loggedUser &&
                                        <Menu.Item color="blue" onClick={signOut}><Text fz="xl" fw={700}>🔓 SIGN OUT</Text></Menu.Item>
                                    }
                                    { !loggedUser &&
                                        <Menu.Item onClick={signIn}><Text fz="xl" fw={700}>🔒 SIGN IN</Text></Menu.Item>
                                    }

                                </Menu.Dropdown>
                            </Menu>

                            <MantineProvider inherit theme={{ defaultGradient: {from: 'yellow', to: 'orange', deg: 45, }, colors: { 'ocean-blue': colors['ocean-blue'], 'bright-pink': colors['bright-pink'], }, }} >
                                <Button size={'xs'} variant="gradient" onClick={() => navTo("/bedetheque")}>BDTHEQUE</Button>
                            </MantineProvider>

                        </Group>
                    </nav>
                </div>
                <div className='navBarRight'>
                    {loggedUser &&
                        <CgProfile size={25} color={ editionMode ? 'crimson' : 'rgb(39, 36, 36)'} onClick={() => { setEditionMode(!editionMode) }} style={{cursor: 'pointer'}}/>
                    }
                </div>
            </div>

        </>
    )
}

export default TopMenu
